import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { switchMap, filter, take } from 'rxjs/operators';

/**
 * Interceptor adds the user's auth token to any HTTP request
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    /**
     * Default constructor for the interceptor 
     * @param _authService AuthService instance to access user token
     */
    constructor(
        private _authService: AuthService,
    ) { }

    /**
     * Intercept any HTTP request 
     * @param req
     * @param next 
     * @returns HTTP Response
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Wait for any token refresh to complete before proceeding
        return this._authService.refreshInProgress$.pipe(
            filter(inProgress => {
                if (inProgress) console.log(`[AUTH-INTERCEPTOR]: blocking ${req.url} on refresh`)
                return !inProgress;
            }), // Only proceed if not refreshing
            take(1),
            switchMap(() => {
                const token = this._authService.token;
                if (token == undefined || token === "") {
                    // If the token is empty, just let the request go through
                    return next.handle(req);
                }
                // Otherwise, add the token to the request
                const reqCopy = req.clone({
                    headers: req.headers.set('Authorization', `Bearer ${token}`),
                });
                return next.handle(reqCopy);
            })
        );
    }
}